import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";

// GlobalRef Context
import { GlobalRefProvider } from "./store/GlobalRefs"; // make sure the path is correct

// AWS Amplify
import { Amplify } from "aws-amplify";

// Amplify v6 config shape. `region` / `identityPoolRegion` are gone — the region is
// inferred from the pool IDs — so REACT_APP_REGION and REACT_APP_IDENTITYPOOLREGION
// in .env are no longer read. `allowGuestAccess` is v6's spelling of v5's
// `mandatorySignIn: false`.
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USERPOOLID,
      userPoolClientId: process.env.REACT_APP_USERPOOLWEBCLIENTID,
      identityPoolId: process.env.REACT_APP_IDENTITYPOOLID,
      allowGuestAccess: true,
    },
  },
});

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <GlobalRefProvider>
        <App />
      </GlobalRefProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
